import { tokens } from 'src/design-system';

export const SEQuoteTaskTabsStyles = () => ({
  container: {
    width: '100%',
  },
  tabLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: tokens.spacing.xs,
  },
  tabSelectedIcon: {
    color: tokens.colors.success,
    fontSize: tokens.fontSize.body,
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: tokens.spacing.md,
    padding: `${tokens.spacing.ms}px ${tokens.spacing.md}px`,
    borderTop: `1px solid ${tokens.colors.border}`,
    backgroundColor: tokens.colors.bgSubtle,
    borderRadius: tokens.radius.md,
  },
  footerBlock: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    '&:not(:first-child)': {
      marginLeft: tokens.spacing.xxl,
    },
  },
  footerLabel: {
    fontSize: tokens.fontSize.caption,
    color: tokens.colors.textSecondary,
  },
  footerValue: {
    fontSize: tokens.fontSize.h3,
    fontWeight: tokens.fontWeight.bold,
    color: tokens.colors.text,
  },
  deviationSummary: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: tokens.spacing.md,
    padding: `${tokens.spacing.md}px ${tokens.spacing.lg}px`,
    backgroundColor: tokens.colors.highlightYellow,
    border: `1px solid ${tokens.colors.warning}`,
    borderRadius: tokens.radius.md,
  },
  deviationRow: {
    display: 'flex',
    flexDirection: 'column',
    '&:not(:first-child)': {
      marginTop: tokens.spacing.xl,
    },
  },
  deviationLabel: {
    fontSize: tokens.fontSize.small,
    color: tokens.colors.textSecondary,
  },
  deviationValue: {
    fontSize: tokens.fontSize.body,
    fontWeight: tokens.fontWeight.semibold,
    color: tokens.colors.text,
    lineHeight: tokens.lineHeight.normal,
    marginTop: tokens.spacing.xs,
  },
});
